import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemSuccess,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  selectItem,
} = getReportActions();

const getConfigsByNamesSuccess = createAction('getConfigsByNamesSuccess');
const updateEquipmentServiceRequest = createAction('updateEquipmentServiceRequest');
const exportEquipmentServiceInvoiceToQuickBooksRequest =
  createAction('exportEquipmentServiceInvoiceToQuickBooksRequest');

export {
  // report
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemSuccess,
  getItemListRequest,
  getItemListSuccess,
  updateReportRequest,
  createReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  // equipment-service-invoice
  selectItem,
  getConfigsByNamesSuccess,
  updateEquipmentServiceRequest,
  exportEquipmentServiceInvoiceToQuickBooksRequest,
};
